'use client'

import { EventDetailContent } from '@/_pages/public/event-detail/event-detail-container'
import { Progress } from '@/components/progress'
import { useSocketIO } from '@/hooks'
import eventService from '@/service/event.service'
import { useParams } from 'next/navigation'
import { useEffect, useState } from 'react'

const UUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/

export const EventDetailPage = () => {
  const params = useParams<{ eventId: string }>()
  const eventId = params?.eventId

  const [loaded, setLoaded] = useState(false)

  useEffect(() => {
    async function rewriteOldId() {
      if (!UUID_REGEX.test(eventId!)) {
        setLoaded(true)
        return
      }

      try {
        const event = await eventService.getEventByOldId(eventId!)
        const id = event?.data?.id
        if (!id) {
          setLoaded(true)
          return
        }

        location.href = location.href.replace(eventId!, id)
      } catch (error) {
        console.error('Error fetching event by old ID:', error)
      }
    }

    rewriteOldId()
  }, [])

  if (!loaded) {
    return null
  }

  if (!eventId) {
    console.warn('No event ID fount!')
    return (
      <Progress
        stages={[
          { isLoaded: false, text: 'Oldal betöltése...' },
          { isLoaded: false, text: 'Kapcsolódás a szerverhez...' },
          { isLoaded: false, text: 'Időpontok betöltése...' },
        ]}
      />
    )
  }

  return <EventDetails eventId={`${eventId}`} />
}

const EventDetails = (props: { eventId: string }) => {
  const websocketServer = `/booking`
  const socket = useSocketIO(websocketServer)

  return socket ? (
    <EventDetailContent eventId={props.eventId} socket={socket} />
  ) : (
    <Progress
      stages={[
        { isLoaded: false, text: 'Oldal betöltése...' },
        { isLoaded: false, text: 'Kapcsolódás a szerverhez...' },
        { isLoaded: false, text: 'Időpontok betöltése...' },
      ]}
    />
  )
}
